import React from "react";

export const filterListings = async (entries, categoryID, subCategoryID, location, searchText, isQueenOfQuality, isPerformanceProgram) => {
    var data = entries;


    if (categoryID != null) {
        data = data.filter(item => item["CategoryID"] == categoryID);
    }

    if (subCategoryID != null && subCategoryID !== '') {
        data = data.filter(item => item["SubCategoryID"] == subCategoryID);
    }

    if (location !== null && location !== '') {
        data = data.filter(item => item["StateProvince"] === location || item["CountryID"] === location);
    }

    if (searchText != null) {
        let search = searchText.replace(/\s/g, '').toLowerCase();
        data = data.filter(
            item =>
                item["IndexName"]?.toLowerCase().includes(search) ||
                item["IndexOrganizationName"]?.toLowerCase().includes(search) ||
                item["OrganizationName"]?.toLowerCase().includes(search) ||
                item["IndexOwnerName"]?.toLowerCase().includes(search)
        );
    }

    if (isQueenOfQuality == true) {
        data = data.filter(item => item["QueenOfQuality"] === isQueenOfQuality);
    }

    // Filter by Performance Program
    if (isPerformanceProgram === 'All') {
    } else if (isPerformanceProgram != null && isPerformanceProgram !== '') {
        data = data.filter(item => item["PerformanceProgram"] === isPerformanceProgram);
    }


    return data;
}

/*
Sorts the provided data based on sort direction or option value provided
*/
export const sortDataBy = async (data, option) => {
    // Separate staff members (CategoryID 5 or 6) from other entries
    const staffMembers = data.filter(item => item.CategoryID === 5 || item.CategoryID === 6);
    const nonStaffMembers = data.filter(item => item.CategoryID !== 5 && item.CategoryID !== 6);

    // Define sorting function for reusability
    const sortByOption = (items, option) => {
        switch (option) {
            case 'nameAZ':
                return [...items].sort((a, b) => {
                    let x = a.IndexOrganizationName && a.IndexOrganizationName.trim() !== "" ? a.IndexOrganizationName : a.IndexName;
                    let y = b.IndexOrganizationName && b.IndexOrganizationName.trim() !== "" ? b.IndexOrganizationName : b.IndexName;
                    return x > y ? 1 : x < y ? -1 : 0;
                });
            case 'nameZA':
                return [...items].sort((a, b) => {
                    let x = a.IndexOrganizationName && a.IndexOrganizationName.trim() !== "" ? a.IndexOrganizationName : a.IndexName;
                    let y = b.IndexOrganizationName && b.IndexOrganizationName.trim() !== "" ? b.IndexOrganizationName : b.IndexName;
                    return x > y ? -1 : x < y ? 1 : 0;
                });
            case 'oldest':
                return [...items].sort((a, b) => {
                    let x = new Date(a.DirectoryListingCDate);
                    let y = new Date(b.DirectoryListingCDate);
                    return x > y ? 1 : x < y ? -1 : 0;
                });
            case 'latest':
                return [...items].sort((a, b) => {
                    let x = new Date(a.DirectoryListingCDate);
                    let y = new Date(b.DirectoryListingCDate);
                    return x > y ? -1 : x < y ? 1 : 0;
                });
            default:
                return [...items];
        }
    };

    // Sort both staff and non-staff members separately
    const sortedNonStaff = sortByOption(nonStaffMembers, option);
    const sortedStaff = sortByOption(staffMembers, option);

    // Combine sorted non-staff and staff members
    return [...sortedNonStaff, ...sortedStaff];
};
